/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import Button from '../../../../components/Button'
import Modal, { ModalHeader } from '../../../../components/Modal'
import Profile from '../../../../components/Profile';
import DeleteIcon from "../../../../assets/images/icon/delete-icon-01.svg";
import IconButton from '../../../../components/Button/IconButton';
import { isEmpty } from '../../../../utils/lodashExtend';
import { postRolesEmployees, deleteRolesEmployees, getRolesIdleEmployees } from '../../../../apis/companies/roles';
import { searchEmployee } from '../../../../utils/employee';
import { forEach } from 'lodash';
import systemAlert from '../../../../utils/systemAlert';
// import { toast } from '../../../../utils/toast';
import PerfectScrollbar from "react-perfect-scrollbar";


const RoleEmployeeModal = ({ open, setOpen, employeeList, role, submit }) => {
  const { employees } = useSelector(
    (store) => ({
      employees: store.Data.employees,
    }),
  );
  const [_employeeList, _setEmployeeList] = useState([])
  const [idleEmployeeList, setIdleEmployeeList] = useState([])
  const [targetEmployee, setTargetEmployee] = useState([])

  useEffect(() => {
    if (employees) {
      const target = []

      forEach(employeeList, (employee) => {
        forEach(employees, (_employee) => {
          if (employee.employeeIdx === _employee.idx) {
            employee = {
              ...employee,
              code: _employee.code,
              partName: _employee.partName,
              email: _employee.email,
            }

            target.push(employee)
          }
        })
      })

      _setEmployeeList(target)
    }
  }, [employeeList, employees])

  // 업무에 배정 가능한 직원 리스트
  useEffect(() => {
    if (!isEmpty(idleEmployeeList)) {
      searchEmployee(
        (employees) => {
          setTargetEmployee(employees);
        },
        targetEmployee,
        { customEmployees: idleEmployeeList }
      );
    }
  }, [idleEmployeeList])

  // 직원 선택
  useEffect(() => {
    if (!isEmpty(targetEmployee)) {
      let body = { employees: [] }
      forEach(employeeList, (employee) => {
        body.employees.push(employee.employeeIdx)
      })

      forEach(targetEmployee, (employee) => {
        body.employees.push(employee.idx)
      })
      postRolesEmployees(role.idx, body).then(() => { submit(); setTargetEmployee([]) })
    }
  }, [employeeList, targetEmployee])

  const handleAddEmployee = () => {
    getRolesIdleEmployees().then((res) => {
      const target = []

      forEach(res.data.employees, (employee) => {
        forEach(employees, (_employee) => {
          if (employee.idx === _employee.idx) {
            employee = {
              ...employee,
              ..._employee
            }

            target.push(employee)
          }
        })
      })

      if (isEmpty(target)) {
        systemAlert('모든 직원이 업무에 배정 되어 있습니다. \n대상인원을 기존업무에서 제외한 후 추가해주세요.')
      }
      setIdleEmployeeList(target)
    })
  }

  const handleDeleteEmployee = (data) => {
    systemAlert(
      `${data.name}님을 해당 업무에서 제외하시겠습니까?`,
      {
        buttons: [
          {
            color: 'text',
            label: '취소'
          },
          {
            label: '삭제',
            onClick: () => {
              deleteRolesEmployees(role.idx, data.idx).then(() => { submit() })
            }
          }
        ]
      })
  }

  const cancel = () => {
    setOpen(false)
  }

  return (
    <Modal size="md" isOpen={open} close={cancel}>
      <div className="role-employee-modal">
        <div className="role-employee-modal-header">
          <ModalHeader className="role-employee-modal-header-title">
            {`${role.roleName} 업무 직원 리스트`}
          </ModalHeader>
          <Button className="float-right" label="사람추가" action={handleAddEmployee} />
        </div>

        <div
          className="role-employee-modal-body"
          style={{
            height: '60vh'
          }}
        >
          <PerfectScrollbar>
            {!isEmpty(_employeeList) ? (
              <table className="role-employee-modal-table">
                <colgroup>
                  <col width="30px"></col>
                  <col width="150px"></col>
                  <col width="60px"></col>
                  <col width="150px"></col>
                  <col width=""></col>
                </colgroup>
                <tbody>
                  {_employeeList.map((employee, employeeIdx) => (
                    <tr key={employeeIdx}>
                      <td>
                        <IconButton
                          icon={DeleteIcon}
                          onClick={() => handleDeleteEmployee(employee)}
                        />
                      </td>
                      <td>
                        <Profile employeeIdx={employee.employeeIdx} />
                      </td>
                      <td>
                        <span className="user-code">({employee.code})</span>
                      </td>
                      <td>
                        <span className="user-part-name">{employee.partName || '-'}</span>
                      </td>
                      <td>
                        <span className="user-email">{employee.email || '-'}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (<>업무에 배정된 직원이 없습니다.</>)}
          </PerfectScrollbar>
        </div>
        <div className="role-employee-modal-footer">
          <Button label="확인" action={cancel} className="close-button" />
        </div>
      </div>
    </Modal>
  )
}

export default RoleEmployeeModal;